module.exports = __webpack_public_path__ + "static/media/ui.3fdea069.svg";